import React, { FC } from "react";
import Heading from "componentsTemplate/Heading/Heading";
import { PostAuthorType } from "data/types";
import CardAuthorBox2 from "componentsTemplate/CardAuthorBox2/CardAuthorBox2";
import MySlider from "componentsTemplate/MySlider";
import CardCategory from "./CardCategory";

export interface SectionSliderCategoriesProps {
  className?: string;
  heading?: string;
  subHeading?: string;
  data: any[];
  itemPerRow?: number;
}

const SectionSliderCategories: FC<SectionSliderCategoriesProps> = ({
  heading = "	Comunidades Radar",
  subHeading = "Popular places to recommends for you",
  className = "",
  data,
  itemPerRow = 5,
}) => {
  return (
    <div className={`nc-SectionSliderNewAuthors ${className}`}>
      <Heading desc={subHeading} isCenter>
        {heading}
      </Heading>
      <MySlider
        itemPerRow={itemPerRow}
        data={data}
        renderItem={(item, index) => (
          <CardCategory key={index} data={item} className="shadow-lg mb-5" />
        )}
      />
    </div>
  );
};

export default SectionSliderCategories;
